/*
* @Author: zxy
 * @Date: 2018-09-21 09:49:27
 * @Desc: 网站配置
 * @Last Modified by: zxy
 * @Last Modified time: 2020-04-22 09:27:39
 */
//  应用前缀名：避免同一个IP:PORT下，Localstorage Key 同名造成冲突
const prefix = '51_'
const base = {
  prefix,
  SITENAME: '51课程',
  VERSION: 'V1.0.01', 
  UPDATE_TOKEN : 'UPDATE_TOKEN', //获取token
  REMOVE_TOKEN : 'REMOVE_TOKEN', //清除token
  UPDATE_TIMEOUT : 'UPDATE_TIMEOUT', //获取过期时间
  REMOVE_TIMEOUT : 'REMOVE_TIMEOUT', //清除过期时间
  UPDATE_TOPMENU : 'UPDATE_TOPMENU', //获取顶部导航列表
  REMOVE_TOPMENU : 'REMOVE_TOPMENU', //清除顶部导航列表
  UPDATE_TOPNAV : 'UPDATE_TOPNAV', //获取顶部导航选中项
  REMOVE_TOPNAV : 'REMOVE_TOPNAV', //清除顶部导航选中项
  UPDATE_LEFTNAV : 'UPDATE_LEFTNAV', //获取左侧导航选中项
  REMOVE_LEFTNAV : 'REMOVE_LEFTNAV', //清除左侧导航选中项
  UPDATE_USERINFO : 'UPDATE_USERINFO', //获取登录用户信息
  REMOVE_USERINFO : 'REMOVE_USERINFO', //清除登录用户信息
  LOGIN_OUT : 'LOGIN_OUT', //登录退出
  UPDATE_COURSEINFO : 'UPDATE_COURSEINFO', //获取课程信息
  REMOVE_COURSEINFO : 'REMOVE_COURSEINFO', //清除课程信息
}

export default base



// WEBPACK FOOTER //
// ./src/config/index.js